/* hk-cart-core-v1 (28 Sep 2026): the one owner of cart shape.

   Why this exists. Three scripts used to change the cart on their own
   schedule: the drawer's steppers, hk-pack-upgrade-v5 (turns loose singles
   into pack prices) and hk-kit-v1 (the free Starter Pack). Each listened for
   cart:update and each wrote to the cart, so one tap on + fanned out into
   several writes. Worse, the pack script zeroed singles BY VARIANT ID, and
   Shopify splits one variant over two lines when the Starter Pack discount is
   allocated, so "zero the Lemon single" only zeroed one of its two lines. The
   next pass then saw a two pack plus a left over single, counted three bottles
   and swapped to the Three Bottle Pack: tapping + on one bottle charged $99.

   The rules now:
   1. Every cart write on the site goes through HKCartQ, a single serial queue.
      A task starts only after the previous one has finished.
   2. Every task reads a fresh /cart.js first and decides from that, never from
      a snapshot taken earlier.
   3. Existing lines are always addressed by their line KEY, never by variant
      id, so a split line can never be half changed.
   4. A task computes the whole target shape (bottles, packs, the free kit) and
      writes it in one request where it can. Nothing reacts to cart:update by
      writing, so nothing can run on its own output.
   5. The auto pack converter runs only inside a task: when an add leaves the
      cart holding exactly 2 or 3 bottles (packs count as bottles) with at least
      one of them a loose single, and once at page load for carts made before.
   6. One free Starter Pack while there is at least one bottle; it leaves when
      the last bottle does (unless she bought the kit on its own first).

   The drawer ladder, one tap = one bottle:
   1 bottle = single, 2 = Two Bottle Pack, 3 = Three Bottle Pack,
   4 = Three Bottle Pack + single, 5 = Three + Two, 6 = two Three Bottle Packs.

   ES5, guarded. If this file fails to load, hkv2-chrome.js and hkv2-pages.js
   fall back to plain AJAX adds so buying still works. */
(function () {
  "use strict";
  if (window.HKCartQ) return;
  if (!window.fetch || !window.Promise || !window.JSON) return;
  /* the retired scripts check these flags and stand down if a stale layout loads them */
  window.__hkPack = true; window.__hkKitV1 = true;

  var SINGLES = { 46931107086535: "LEM", 46931107119303: "MAN", 46931107152071: "PEP", 46931107184839: "FF" };
  var PACK2 = { "FF|FF": 46931107741895, "FF|LEM": 46931107348679, "FF|MAN": 46931107479751,
    "FF|PEP": 46931107610823, "LEM|LEM": 46931107250375, "LEM|MAN": 46931107283143,
    "LEM|PEP": 46931107315911, "MAN|MAN": 46931107414215, "MAN|PEP": 46931107446983,
    "PEP|PEP": 46931107578055 };
  var PACK3 = { "FF|FF|FF": 46931109871815, "FF|FF|LEM": 46931108298951, "FF|FF|MAN": 46931108823239,
    "FF|FF|PEP": 46931109347527, "FF|LEM|LEM": 46931107905735, "FF|LEM|MAN": 46931108036807,
    "FF|LEM|PEP": 46931108167879, "FF|MAN|MAN": 46931108561095, "FF|MAN|PEP": 46931108692167,
    "FF|PEP|PEP": 46931109216455, "LEM|LEM|LEM": 46931107807431, "LEM|LEM|MAN": 46931107840199,
    "LEM|LEM|PEP": 46931107872967, "LEM|MAN|MAN": 46931107971271, "LEM|MAN|PEP": 46931108004039,
    "LEM|PEP|PEP": 46931108135111, "MAN|MAN|MAN": 46931108495559, "MAN|MAN|PEP": 46931108528327,
    "MAN|PEP|PEP": 46931108659399, "PEP|PEP|PEP": 46931109183687 };
  /* every pack variant in the store (one per ORDER of scents), value = sorted key */
  var PACK_ALL = {
    46931107250375: "LEM|LEM", 46931107283143: "LEM|MAN", 46931107315911: "LEM|PEP",
    46931107348679: "FF|LEM", 46931107381447: "LEM|MAN", 46931107414215: "MAN|MAN",
    46931107446983: "MAN|PEP", 46931107479751: "FF|MAN", 46931107512519: "LEM|PEP",
    46931107545287: "MAN|PEP", 46931107578055: "PEP|PEP", 46931107610823: "FF|PEP",
    46931107643591: "FF|LEM", 46931107676359: "FF|MAN", 46931107709127: "FF|PEP",
    46931107741895: "FF|FF", 46931107807431: "LEM|LEM|LEM", 46931107840199: "LEM|LEM|MAN",
    46931107872967: "LEM|LEM|PEP", 46931107905735: "FF|LEM|LEM", 46931107938503: "LEM|LEM|MAN",
    46931107971271: "LEM|MAN|MAN", 46931108004039: "LEM|MAN|PEP", 46931108036807: "FF|LEM|MAN",
    46931108069575: "LEM|LEM|PEP", 46931108102343: "LEM|MAN|PEP", 46931108135111: "LEM|PEP|PEP",
    46931108167879: "FF|LEM|PEP", 46931108200647: "FF|LEM|LEM", 46931108233415: "FF|LEM|MAN",
    46931108266183: "FF|LEM|PEP", 46931108298951: "FF|FF|LEM", 46931108331719: "LEM|LEM|MAN",
    46931108364487: "LEM|MAN|MAN", 46931108397255: "LEM|MAN|PEP", 46931108430023: "FF|LEM|MAN",
    46931108462791: "LEM|MAN|MAN", 46931108495559: "MAN|MAN|MAN", 46931108528327: "MAN|MAN|PEP",
    46931108561095: "FF|MAN|MAN", 46931108593863: "LEM|MAN|PEP", 46931108626631: "MAN|MAN|PEP",
    46931108659399: "MAN|PEP|PEP", 46931108692167: "FF|MAN|PEP", 46931108724935: "FF|LEM|MAN",
    46931108757703: "FF|MAN|MAN", 46931108790471: "FF|MAN|PEP", 46931108823239: "FF|FF|MAN",
    46931108856007: "LEM|LEM|PEP", 46931108888775: "LEM|MAN|PEP", 46931108921543: "LEM|PEP|PEP",
    46931108954311: "FF|LEM|PEP", 46931108987079: "LEM|MAN|PEP", 46931109019847: "MAN|MAN|PEP",
    46931109052615: "MAN|PEP|PEP", 46931109085383: "FF|MAN|PEP", 46931109118151: "LEM|PEP|PEP",
    46931109150919: "MAN|PEP|PEP", 46931109183687: "PEP|PEP|PEP", 46931109216455: "FF|PEP|PEP",
    46931109249223: "FF|LEM|PEP", 46931109281991: "FF|MAN|PEP", 46931109314759: "FF|PEP|PEP",
    46931109347527: "FF|FF|PEP", 46931109380295: "FF|LEM|LEM", 46931109413063: "FF|LEM|MAN",
    46931109445831: "FF|LEM|PEP", 46931109478599: "FF|FF|LEM", 46931109511367: "FF|LEM|MAN",
    46931109544135: "FF|MAN|MAN", 46931109576903: "FF|MAN|PEP", 46931109609671: "FF|FF|MAN",
    46931109642439: "FF|LEM|PEP", 46931109675207: "FF|MAN|PEP", 46931109707975: "FF|PEP|PEP",
    46931109740743: "FF|FF|PEP", 46931109773511: "FF|FF|LEM", 46931109806279: "FF|FF|MAN",
    46931109839047: "FF|FF|PEP", 46931109871815: "FF|FF|FF"
  };
  var PACK_CONTENTS = {};
  (function () { for (var id in PACK_ALL) if (PACK_ALL.hasOwnProperty(id)) PACK_CONTENTS[id] = PACK_ALL[id].split("|"); })();
  var SINGLE_LIST = [
    { id: 46931107086535, code: "LEM", name: "Lemon Myrtle + Eucalyptus" },
    { id: 46931107119303, code: "MAN", name: "Mandarin Peel + Rosemary" },
    { id: 46931107152071, code: "PEP", name: "Peppermint + Pine Needle" },
    { id: 46931107184839, code: "FF",  name: "Fragrance Free" }
  ];
  var CODE = { "Lemon Myrtle + Eucalyptus": "LEM", "Mandarin Peel + Rosemary": "MAN", "Peppermint + Pine Needle": "PEP", "Fragrance Free": "FF" };
  var K_OF = { "all-in-one-cleaner-concentrate": 1, "two-bottle-pack": 2, "three-bottle-pack": 3 };
  var HANDLE_OF = { 1: "all-in-one-cleaner-concentrate", 2: "two-bottle-pack", 3: "three-bottle-pack" };
  var KIT = "starter-pack";
  var H = window.HKV2 || {};

  /* ---------- small helpers ---------- */
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} return null; }
  /* Shopify answers a burst of cart calls with 429 (and the odd 5xx). Those are
     retried twice with a short pause; a 422 (sold out, too many) is a real answer
     and goes straight back to the caller. Nothing else changes the cart meanwhile,
     because the retry happens inside the queue task. */
  function req(url, body, tries) {
    tries = tries || 0;
    return fetch(url, { method: body ? "POST" : "GET", credentials: "same-origin", cache: "no-store",
      headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) {
        if ((r.status === 429 || r.status >= 500) && tries < 2) return new Promise(function (ok) { setTimeout(ok, 1200 * (tries + 1)); }).then(function () { return req(url, body, tries + 1); });
        return r.json().then(function (j) { if (!r.ok) { j = j || {}; j.status = r.status; throw j; } return j; },
          function () { if (!r.ok) throw { status: r.status, description: "That did not update. Please try again." }; return null; });
      });
  }
  function fresh() { return req("/cart.js"); }
  function codesOfTitle(t) {
    var parts = String(t || "").split(" / "), out = [];
    for (var i = 0; i < parts.length; i++) { var c = CODE[parts[i].replace(/^\s+|\s+$/g, "")]; if (!c) return null; out.push(c); }
    return out;
  }
  function codesOfId(id) { return SINGLES[id] ? [SINGLES[id]] : (PACK_CONTENTS[id] ? PACK_CONTENTS[id].slice() : null); }
  function sortedKey(codes) { return codes.slice().sort().join("|"); }

  /* The cart in bottles. units: one entry per bottle unit (a single, or one pack),
     in the order Three packs, Two packs, singles, each tagged with its line key. */
  function analyse(cart) {
    var A = { n: 0, units: [], singles: 0, unsafe: false, kitQty: 0, kitKeys: [], kitFree: false, bottleLines: [] };
    var byK = { 3: [], 2: [], 1: [] };
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i], k = K_OF[it.handle];
      if (k) {
        var codes = codesOfTitle(it.variant_title) || codesOfId(it.variant_id);
        if (!codes || codes.length !== k) { A.unsafe = true; codes = []; for (var z = 0; z < k; z++) codes.push("?"); }
        A.bottleLines.push(it);
        for (var q = 0; q < it.quantity; q++) byK[k].push({ k: k, codes: codes.slice(), key: it.key, vid: String(it.variant_id) });
        A.n += k * it.quantity; if (k === 1) A.singles += it.quantity;
      } else if (it.handle === KIT) {
        A.kitQty += it.quantity; A.kitKeys.push(it.key); if (it.final_line_price === 0) A.kitFree = true;
      }
    }
    A.units = byK[3].concat(byK[2], byK[1]);
    return A;
  }

  /* ---------- live stock, so a conversion never asks for a sold out variant ---------- */
  var prod = {};
  function product(k, force) {
    if (prod[k] && !force) return Promise.resolve(prod[k]);
    return req("/products/" + HANDLE_OF[k] + ".js").then(function (p) {
      var list = [];
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i], cs = codesOfTitle(v.title);
        if (cs && cs.length === k) list.push({ id: String(v.id), key: sortedKey(cs), ord: cs.join("|"), available: !!v.available });
      }
      prod[k] = list; return list;
    });
  }
  function canonical(k, key) {
    if (k === 1) { for (var id in SINGLES) if (SINGLES.hasOwnProperty(id) && SINGLES[id] === key) return String(id); return null; }
    var t = k === 2 ? PACK2 : PACK3; return t[key] ? String(t[key]) : null;
  }
  /* chunks: arrays of scent codes (1, 2 or 3 long). Returns {variantId: qty} or null
     when any chunk has no variant in stock. Prefers a variant already in the cart,
     then the canonical one, so a working cart is never churned. */
  function buildTarget(chunks, A, force) {
    var need = {}, ks = {};
    for (var i = 0; i < chunks.length; i++) {
      var k = chunks[i].length, key = sortedKey(chunks[i]);
      if (key.indexOf("?") > -1) return Promise.resolve(null);
      var g = k + "#" + key; need[g] = (need[g] || 0) + 1; ks[k] = 1;
    }
    var kl = []; for (var kk in ks) if (ks.hasOwnProperty(kk)) kl.push(+kk);
    return Promise.all(kl.map(function (k) { return product(k, force); })).then(function () {
      var target = {}, inCart = {};
      for (var b = 0; b < A.bottleLines.length; b++) inCart[String(A.bottleLines[b].variant_id)] = 1;
      for (var gk in need) {
        if (!need.hasOwnProperty(gk)) continue;
        var k = +gk.split("#")[0], key = gk.split("#")[1], list = prod[k] || [], av = [], pick = null;
        for (var j = 0; j < list.length; j++) if (list[j].key === key && list[j].available) av.push(list[j].id);
        if (!av.length) return null;
        for (j = 0; j < av.length && !pick; j++) if (inCart[av[j]]) pick = av[j];
        var c = canonical(k, key); if (!pick && c && av.indexOf(c) > -1) pick = c;
        if (!pick) pick = av[0];
        target[pick] = (target[pick] || 0) + need[gk];
      }
      return target;
    });
  }
  /* Bottle lines to their target, by line key. Returns null when nothing changes. */
  function diffBottles(cart, A, target) {
    var up = {}, seen = {}, have = {}, changed = false, v;
    for (var i = 0; i < A.bottleLines.length; i++) {
      var it = A.bottleLines[i]; v = String(it.variant_id);
      have[v] = (have[v] || 0) + it.quantity;
      if (target[v] && !seen[v]) { up[it.key] = target[v]; seen[v] = true; } else up[it.key] = 0;
    }
    for (v in target) if (target.hasOwnProperty(v) && !seen[v] && target[v] > 0) up[v] = target[v];
    for (v in target) if (target.hasOwnProperty(v) && (have[v] || 0) !== target[v]) changed = true;
    for (v in have) if (have.hasOwnProperty(v) && !target[v]) changed = true;
    return changed ? up : null;
  }
  function chunk(flat) {
    var out = [], i = 0, n = flat.length;
    while (n - i >= 3) { out.push(flat.slice(i, i + 3)); i += 3; }
    if (n - i > 0) out.push(flat.slice(i));
    return out;
  }

  /* ---------- the free Starter Pack ---------- */
  var kitId = H.kit ? String(H.kit) : null;
  function kitVariant() {
    if (kitId) return Promise.resolve(kitId);
    return req("/products/" + KIT + ".js").then(function (p) { kitId = p && p.variants && p.variants[0] ? String(p.variants[0].id) : null; return kitId; }, function () { return null; });
  }
  var dismissed = false;
  /* Adds the kit to `up` when bottles arrive, takes one away when the last bottle leaves. */
  function planKit(A, n2, up) {
    if (n2 >= 1 && A.kitQty === 0 && !dismissed) {
      return kitVariant().then(function (id) { if (id) { up[id] = 1; return "added"; } return null; });
    }
    if (A.n >= 1 && n2 === 0 && A.kitQty >= 1 && ss("hkq_kit") !== "own") {
      for (var i = 0; i < A.kitKeys.length; i++) up[A.kitKeys[i]] = i ? 0 : A.kitQty - 1;
      return Promise.resolve("removed");
    }
    return Promise.resolve(null);
  }
  function kitAfter(r) { if (r === "added") ss("hkq_kit", "auto"); else if (r === "removed") ss("hkq_kit", null); }

  /* ---------- the queue ---------- */
  var chain = Promise.resolve(), depth = 0;
  function busy(on) {
    var els = document.querySelectorAll("[data-hk-cart-body], [data-hk-cart-dyn]");
    for (var i = 0; i < els.length; i++) { if (on) els[i].setAttribute("aria-busy", "true"); else els[i].removeAttribute("aria-busy"); }
  }
  function enqueue(fn) {
    depth++; busy(true);
    var p = chain.then(fn);
    chain = p.then(function () {}, function () {});
    var end = function () { depth--; if (!depth) busy(false); };
    return p.then(function (c) { end(); return c; }, function (e) { end(); throw e; });
  }
  function announce(cart, extra) {
    if (!cart || !cart.items) return cart;
    var ev; try { ev = new Event("cart:update", { bubbles: true }); } catch (e) { ev = document.createEvent("Event"); ev.initEvent("cart:update", true, false); }
    var data = { source: "hk-cartq", itemCount: cart.item_count };
    if (extra) for (var k in extra) if (extra.hasOwnProperty(k)) data[k] = extra[k];
    ev.detail = { resource: cart, sourceId: "hk-cartq", data: data };
    document.dispatchEvent(ev);
    return cart;
  }
  function update(up) { return req("/cart/update.js", { updates: up }); }
  function isEmpty(o) { for (var k in o) if (o.hasOwnProperty(k)) return false; return true; }

  /* After a conversion, the cart must hold exactly the bottles we asked for. If
     Shopify declined part of it (stock moved under us), put the original bottle
     lines back rather than leave her short. */
  function verify(before, A, n2, cart) {
    var B = analyse(cart);
    if (B.n === n2) return Promise.resolve(cart);
    var up = {};
    for (var i = 0; i < B.bottleLines.length; i++) up[B.bottleLines[i].key] = 0;
    for (i = 0; i < A.bottleLines.length; i++) { var v = String(A.bottleLines[i].variant_id); up[v] = (up[v] || 0) + A.bottleLines[i].quantity; }
    prod = {};
    return update(up).then(function (c) { var e = { description: "That pack just sold out. Your bottles are still in your cart." }; e.cart = c; throw e; });
  }

  /* ---------- operations ---------- */
  /* add: items [{id, quantity}] from the product page, quick add, sticky bar, kit buttons. */
  function add(items) {
    return enqueue(function () {
      return fresh().then(function (cart) {
        var A = analyse(cart), addN = 0, addFlat = [], addSingle = false, kitIn = false, other = [];
        for (var i = 0; i < items.length; i++) {
          var id = String(items[i].id), q = Math.max(1, +items[i].quantity || 1), cs = codesOfId(id);
          if (cs) { for (var n = 0; n < q; n++) addFlat = addFlat.concat(cs); addN += cs.length * q; if (cs.length === 1) addSingle = true; }
          else { if (kitId && id === kitId) kitIn = true; other.push({ id: id, quantity: q }); }
        }
        if (kitIn && A.n === 0 && addN === 0) ss("hkq_kit", "own");
        var n2 = A.n + addN, flat = [];
        for (var u = 0; u < A.units.length; u++) flat = flat.concat(A.units[u].codes);
        flat = flat.concat(addFlat);
        var convert = addN > 0 && !A.unsafe && (n2 === 2 || n2 === 3) && (addSingle || A.singles > 0);
        var plain = function () {
          var list = items.slice(), extra = Promise.resolve(null);
          if (addN > 0 && A.kitQty === 0 && !kitIn && !dismissed) extra = kitVariant();
          return extra.then(function (kid) {
            if (kid) list.push({ id: +kid, quantity: 1 });
            return req("/cart/add.js", { items: list }).then(function () { if (kid) kitAfter("added"); }, function (e) {
              if (!kid) throw e;
              return req("/cart/add.js", { items: items });   /* the kit is out of stock: the bottle still goes in */
            });
          }).then(fresh).then(function (c) { return announce(c); });
        };
        if (!convert) return plain();
        return buildTarget([flat], A).then(function (target) {
          if (!target) return plain();
          var up = diffBottles(cart, A, target) || {};
          for (var o = 0; o < other.length; o++) {
            var ex = 0, key = null;
            for (var c = 0; c < cart.items.length; c++) if (String(cart.items[c].variant_id) === other[o].id) { ex += cart.items[c].quantity; if (!key) key = cart.items[c].key; else up[cart.items[c].key] = 0; }
            up[key || other[o].id] = ex + other[o].quantity;
          }
          return planKit(A, n2, kitIn ? {} : up).then(function (kr) {
            return update(up).then(function (c) { kitAfter(kr); return verify(cart, A, n2, c); })
              .then(function (c) { return announce(c, { converted: n2 }); });
          });
        });
      });
    });
  }

  /* step: the + and - on a cart line (drawer and /cart page). keys: the line keys
     the drawer merged into one row. dir: +1 or -1. hint: the scent to add if the
     row has already been replaced by an earlier tap (a fast double tap). */
  function step(keys, dir, hint) {
    keys = String(keys || "").split(",");
    return enqueue(function () {
      return fresh().then(function (cart) {
        var A = analyse(cart), mine = [], i;
        for (i = 0; i < cart.items.length; i++) if (keys.indexOf(cart.items[i].key) > -1) mine.push(cart.items[i]);
        var bottleRow = mine.length ? !!K_OF[mine[0].handle] : !!(hint && hint.bottle);
        if (!mine.length && !(bottleRow && A.n > 0)) return announce(cart);
        var naive = function () {
          if (!mine.length) return Promise.resolve(announce(cart));
          var q = 0, up = {}; for (var m = 0; m < mine.length; m++) q += mine[m].quantity;
          var nq = Math.max(0, q + dir);
          for (m = 0; m < mine.length; m++) up[mine[m].key] = m ? 0 : nq;
          if (mine[0].handle === KIT && nq === 0) { if (A.n > 0) dismissed = true; ss("hkq_kit", null); }
          var n2 = K_OF[mine[0].handle] ? A.n + dir * K_OF[mine[0].handle] : A.n;
          return planKit(A, n2, up).then(function (kr) { return update(up).then(function (c) { kitAfter(kr); return announce(c); }); });
        };
        if (!bottleRow || A.unsafe) return naive();
        /* the flat list of scents in ladder order, and where this row's bottles end */
        var flat = [], owner = [], last = -1;
        for (var u = 0; u < A.units.length; u++) {
          for (var c = 0; c < A.units[u].codes.length; c++) { flat.push(A.units[u].codes[c]); owner.push(u); }
          if (keys.indexOf(A.units[u].key) > -1) last = u;
        }
        var rowCodes = [];
        for (u = 0; u < A.units.length; u++) if (keys.indexOf(A.units[u].key) > -1) rowCodes = rowCodes.concat(A.units[u].codes);
        if (dir > 0) {
          var code = majority(rowCodes.length ? rowCodes : [hint && hint.code || flat[flat.length - 1]]);
          var at = flat.length;
          if (last > -1) { at = 0; for (var f = 0; f < owner.length; f++) if (owner[f] <= last) at = f + 1; }
          flat.splice(at, 0, code);
        } else {
          /* take away one bottle of the scent this row holds most of, from its last
             pack, so "Add a third" then - gives back the pair she had */
          var cut = flat.length - 1;
          if (last > -1) {
            var drop = majority(rowCodes), lastAny = -1; cut = -1;
            for (var g = owner.length - 1; g >= 0; g--) if (owner[g] === last) { if (lastAny < 0) lastAny = g; if (cut < 0 && flat[g] === drop) cut = g; }
            if (cut < 0) cut = lastAny;
          }
          flat.splice(cut, 1);
        }
        var n2 = flat.length;
        if (n2 === 0) {
          var up0 = {}; for (i = 0; i < A.bottleLines.length; i++) up0[A.bottleLines[i].key] = 0;
          return planKit(A, 0, up0).then(function (kr) { return update(up0).then(function (c) { kitAfter(kr); return announce(c); }); });
        }
        return buildTarget(chunk(flat), A).then(function (target) {
          if (!target) return naive();
          var up = diffBottles(cart, A, target);
          if (!up) return announce(cart);
          return planKit(A, n2, up).then(function (kr) {
            return update(up).then(function (c) { kitAfter(kr); return verify(cart, A, n2, c); }).then(function (c) { return announce(c); });
          });
        });
      });
    });
  }
  function majority(codes) {
    var c = {}, best = codes[0];
    for (var i = 0; i < codes.length; i++) { c[codes[i]] = (c[codes[i]] || 0) + 1; if (c[codes[i]] > c[best]) best = codes[i]; }
    return best || "LEM";
  }

  /* swapTo: "Make it two" (k 2) and "Add a third" (k 3). Keeps the scents already
     chosen; the new bottle is Mandarin unless Mandarin is already in, then Lemon
     Myrtle (the concept's swapTo). Only acts on the cart it was offered for. */
  function swapTo(k) {
    return enqueue(function () {
      return fresh().then(function (cart) {
        var A = analyse(cart);
        if (A.unsafe || A.n !== k - 1) return announce(cart);
        var flat = []; for (var u = 0; u < A.units.length; u++) flat = flat.concat(A.units[u].codes);
        var first = flat.slice(); while (first.length < k) first.push(first.indexOf("MAN") < 0 ? "MAN" : "LEM");
        var second = flat.slice(); while (second.length < k) second.push(second.indexOf("MAN") < 0 ? "LEM" : "MAN");
        var third = flat.slice(); while (third.length < k) third.push(flat[0] || "LEM");
        var tryAll = function (list) {
          if (!list.length) throw { description: "That pack is sold out right now." };
          return buildTarget([list[0]], A, true).then(function (t) { return t || tryAll(list.slice(1)); });
        };
        return tryAll([first, second, third]).then(function (target) {
          var up = diffBottles(cart, A, target);
          if (!up) return announce(cart);
          return planKit(A, k, up).then(function (kr) {
            return update(up).then(function (c) { kitAfter(kr); return verify(cart, A, k, c); }).then(function (c) { return announce(c, { swapped: k }); });
          });
        });
      });
    });
  }

  /* rescent (v2.4): "Change scents" inside a cart line. keys: the line keys the drawer
     merged into that row (one variant, possibly split by a discount). codes: the new
     scent per bottle, in bottle order ("LEM", "MAN", ...). One request: every old key
     goes to 0 and the matching variant arrives with the same quantity. The variant is
     the exact bottle order if it is in stock, else any in stock variant holding the
     same scents (order does not matter to what she gets). The Starter Pack lines are
     not touched: the bottle count does not change, so the free kit stays as it is.
     If Shopify declines, the original line is put back and the caller gets a message. */
  function rescent(keys, codes) {
    keys = String(keys || "").split(",");
    codes = (codes || []).slice();
    return enqueue(function () {
      return fresh().then(function (cart) {
        var A = analyse(cart), mine = [], i, qty = 0;
        for (i = 0; i < cart.items.length; i++) if (keys.indexOf(cart.items[i].key) > -1) mine.push(cart.items[i]);
        if (!mine.length) { var gone = { description: "That line changed a moment ago. Please try again." }; gone.cart = announce(cart); throw gone; }
        var k = K_OF[mine[0].handle];
        if (!k || codes.length !== k) throw { description: "Those scents do not fit this line. Please try again.", cart: cart };
        for (i = 0; i < mine.length; i++) qty += mine[i].quantity;
        var oldId = String(mine[0].variant_id);
        return product(k, true).then(function (list) {
          var ord = codes.join("|"), key = sortedKey(codes), pick = null, j;
          for (j = 0; j < list.length && !pick; j++) if (list[j].ord === ord && list[j].available) pick = list[j].id;
          if (!pick) for (j = 0; j < list.length && !pick; j++) if (list[j].key === key && list[j].available && list[j].id === oldId) pick = list[j].id;
          if (!pick) { var c = canonical(k, key); for (j = 0; j < list.length && !pick; j++) if (list[j].id === c && list[j].available) pick = c; }
          if (!pick) for (j = 0; j < list.length && !pick; j++) if (list[j].key === key && list[j].available) pick = list[j].id;
          if (!pick) throw { description: "That mix is sold out right now. Your cart has not changed.", cart: cart };
          if (pick === oldId) return announce(cart, { rescented: pick });
          var up = {}, other = 0, firstOther = null;
          for (j = 0; j < mine.length; j++) up[mine[j].key] = 0;
          /* the new variant may already be in the cart on another line: add to it by key */
          for (j = 0; j < cart.items.length; j++) {
            var it = cart.items[j];
            if (String(it.variant_id) === pick && keys.indexOf(it.key) < 0) { other += it.quantity; if (!firstOther) firstOther = it.key; else up[it.key] = 0; }
          }
          if (firstOther) up[firstOther] = other + qty; else up[pick] = qty;
          return update(up).then(function (c) { return verify(cart, A, A.n, c); })
            .then(function (c) { return announce(c, { rescented: pick }); });
        });
      });
    });
  }

  /* attributes (gift note, refill reminder): serialised with everything else, no redraw */
  function attrs(o) { return enqueue(function () { return req("/cart/update.js", { attributes: o }); }); }

  /* normalise: once per page load, for carts built before this file existed (or in
     another tab): loose singles that make exactly 2 or 3 bottles become the pack,
     and a bottle order gets its free kit. Writes nothing when the cart is right. */
  function normalise() {
    return enqueue(function () {
      return fresh().then(function (cart) {
        var A = analyse(cart), up = {}, n2 = A.n;
        var go = function () {
          return planKit(A, n2, up).then(function (kr) {
            if (isEmpty(up)) return cart;
            return update(up).then(function (c) { kitAfter(kr); return announce(c); });
          });
        };
        if (A.unsafe || !(A.n === 2 || A.n === 3) || !A.singles) return go();
        var flat = []; for (var u = 0; u < A.units.length; u++) flat = flat.concat(A.units[u].codes);
        return buildTarget([flat], A).then(function (t) { if (t) { var d = diffBottles(cart, A, t); if (d) up = d; } return go(); });
      });
    });
  }

  window.HKCartQ = { add: add, step: step, swapTo: swapTo, rescent: rescent, attrs: attrs, normalise: normalise, read: function () { return enqueue(fresh); }, analyse: analyse, VER: "2026-09-28b" };

  /* The tables other scripts read (hkv2-chrome's swap preview, hk-cro-v15's bar).
     evaluate() is kept for old callers and now just runs the queued normalise. */
  function summarise(cart) {
    var scents = [], updates = {}, lines = 0, foreign = 0, already = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i], single = SINGLES[it.variant_id], contents = PACK_CONTENTS[it.variant_id];
      if (single) { for (var n = 0; n < it.quantity; n++) scents.push(single); updates[it.key] = 0; lines++; }
      else if (contents) { for (var q = 0; q < it.quantity; q++) scents = scents.concat(contents); updates[it.key] = 0; lines++; already = it.variant_id; }
      else if (it.final_line_price > 0 && it.handle !== KIT) foreign++;
    }
    return { scents: scents, updates: updates, lines: lines, foreign: foreign, already: already };
  }
  window.HK_PACK = { VER: "core-2026-09-28a", SINGLES: SINGLES, SINGLE_LIST: SINGLE_LIST, PACK2: PACK2, PACK3: PACK3,
    PACK_CONTENTS: PACK_CONTENTS, SAVE2_CENTS: 998, SAVE3_CENTS: 2097, summarise: summarise, evaluate: function () { return normalise(); } };

  function boot() { setTimeout(function () { normalise().catch(function () {}); }, 600); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
